<script setup>
import LogoutItem from './LogoutItem.vue';
import ThemeToggle from './shared/ThemeToggle.vue';
</script>

<template>
  <div>
    <div class="navbar">
      <div class="navbar-left">
        <div v-if="isLoggedIn" class="goBack" @click="goBack()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          <span>Vissza</span>
        </div>
        
        <!-- Logo/Brand -->
        <div class="brand">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
          </svg>
          <span>RSPCT-Core</span>
        </div>
        
        <!-- Desktop Navigation -->
        <ul class="nav-links desktop-nav">
          <li v-if="isLoggedIn">
            <router-link to="/" class="nav-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9,22 9,12 15,12 15,22"/>
              </svg>
              Kezdőlap
            </router-link>
          </li>
          <li v-if="!isLoggedIn">
            <router-link to="/login" class="nav-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                <polyline points="10,17 15,12 10,7"/>
                <line x1="15" y1="12" x2="3" y2="12"/>
              </svg>
              Bejelentkezés
            </router-link>
          </li>
          <li v-if="isLoggedIn && (isAdmin || isTeacher || isAssistant)">
            <router-link to="/settings" class="nav-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="3"/>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
              </svg>
              {{ isTeacher && !isAdmin ? 'Csoportok' : 'Funkciók' }}
            </router-link>
          </li>
          <li v-if="isLoggedIn && (isAdmin || isTeacher || isAssistant)">
            <router-link to="/statistics" class="nav-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M18 20V10M12 20V4M6 20v-6"/>
              </svg>
              Statisztika
            </router-link>
          </li>
          <li v-if="isLoggedIn && (isAdmin || isTeacher || isAssistant)">
            <router-link to="/message-center" class="nav-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                <line x1="9" y1="9" x2="15" y2="9"/>
                <line x1="9" y1="13" x2="13" y2="13"/>
              </svg>
              Üzenetek
            </router-link>
          </li>
          <li v-if="isLoggedIn">
            <router-link to="/public-galas" class="nav-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12.01" y2="12"/>
              </svg>
              Gala
            </router-link>
          </li>
          <li v-if="isLoggedIn">
            <router-link to="/calendars" class="nav-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              Naptár
            </router-link>
          </li>
          <li v-if="isLoggedIn">
            <router-link to="/aktuális-infok" class="nav-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14,2 14,8 20,8"/>
                <line x1="8" y1="13" x2="16" y2="13"/>
                <line x1="8" y1="17" x2="16" y2="17"/>
              </svg>
              Aktuális infók
            </router-link>
          </li>
          <li v-if="isLoggedIn && (isAdmin || isTeacher || isAssistant)">
            <router-link to="/receipts" class="nav-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16v16H4z"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/>
              </svg>
              Számlák
            </router-link>
          </li>
          <li v-if="isLoggedIn && (isAdmin || isTeacher || isAssistant)">
            <router-link to="/calendars" class="nav-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              Naptárak
            </router-link>
          </li>
          <li v-if="isLoggedIn && isAdmin">
            <router-link to="/custsettings" class="nav-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              Beállítások
            </router-link>
          </li>
        </ul>
      </div>
      
      <!-- Theme Toggle -->
      <div class="theme-toggle-nav" v-if="isLoggedIn">
        <ThemeToggle :showStatus="false" />
      </div>
      
      <LogoutItem class="desktop-logout" v-if="isLoggedIn" />

      <!-- Hamburger Button -->
      <div class="hamburger" @click="toggleMenu">
        <div class="bar" :class="{ active: menuOpen }"></div>
        <div class="bar" :class="{ active: menuOpen }"></div>
        <div class="bar" :class="{ active: menuOpen }"></div>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div v-if="menuOpen" class="mobile-menu">
      <ul class="nav-links mobile-nav-links">
        <li v-if="isLoggedIn">
          <router-link to="/" @click="closeMenu" class="nav-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9,22 9,12 15,12 15,22"/>
            </svg>
            Kezdőlap
          </router-link>
        </li>
        <li v-if="!isLoggedIn">
          <router-link to="/login" @click="closeMenu" class="nav-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
              <polyline points="10,17 15,12 10,7"/>
              <line x1="15" y1="12" x2="3" y2="12"/>
            </svg>
            Bejelentkezés
          </router-link>
        </li>
        <li v-if="isLoggedIn && (isAdmin || isTeacher || isAssistant)">
          <router-link to="/settings" @click="closeMenu" class="nav-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="3"/>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
            </svg>
            {{ isTeacher && !isAdmin ? 'Csoportok' : 'Funkciók' }}
          </router-link>
        </li>
        <li v-if="isLoggedIn && isAdmin">
          <router-link to="/statistics" @click="closeMenu" class="nav-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 20V10M12 20V4M6 20v-6"/>
            </svg>
            Statisztika
          </router-link>
        </li>
        <li v-if="isLoggedIn && (isAdmin || isTeacher || isAssistant)">
          <router-link to="/message-center" @click="closeMenu" class="nav-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              <line x1="9" y1="9" x2="15" y2="9"/>
              <line x1="9" y1="13" x2="13" y2="13"/>
            </svg>
            Üzenetek
          </router-link>
        </li>
        <li v-if="isLoggedIn">
          <router-link to="/public-galas" @click="closeMenu" class="nav-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12.01" y2="12"/>
            </svg>
            Gala
          </router-link>
        </li>
        <li v-if="isLoggedIn">
          <router-link to="/calendars" @click="closeMenu" class="nav-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            Naptár
          </router-link>
        </li>
        <li v-if="isLoggedIn">
          <router-link to="/aktuális-infok" @click="closeMenu" class="nav-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14,2 14,8 20,8"/>
            </svg>
            Aktuális infók
          </router-link>
        </li>
        <li v-if="isLoggedIn && (isAdmin || isTeacher || isAssistant)">
          <router-link to="/receipts" @click="closeMenu" class="nav-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M4 4h16v16H4z"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/>
            </svg>
            Számlák
          </router-link>
        </li>
        <li v-if="isLoggedIn && (isAdmin || isTeacher || isAssistant)">
          <router-link to="/calendars" @click="closeMenu" class="nav-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            Naptárak
          </router-link>
        </li>
        <li v-if="isLoggedIn && isAdmin">
          <router-link to="/custsettings" @click="closeMenu" class="nav-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
            Beállítások
          </router-link>
        </li>
        <li v-if="isLoggedIn">
          <div class="mobile-theme-toggle">
            <ThemeToggle :showStatus="true" />
          </div>
        </li>
        <li v-if="isLoggedIn">
          <LogoutItem @click="closeMenu" />
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.navbar {
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--primary-blue-dark) 100%);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  box-shadow: var(--shadow-md);
  backdrop-filter: blur(10px);
}

.navbar-left {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 1.25rem;
  color: white;
}

.brand svg {
  color: var(--accent-blue);
}

.goBack {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 0.875rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.goBack:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: background 0.3s ease;
}

.hamburger:hover {
  background: rgba(255, 255, 255, 0.1);
}

.bar {
  height: 3px;
  width: 25px;
  background-color: white;
  margin: 2px 0;
  transition: all 0.3s ease;
  border-radius: 2px;
}

.bar.active:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.bar.active:nth-child(2) {
  opacity: 0;
}

.bar.active:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -6px);
}

.nav-links {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

.desktop-nav {
  flex-direction: row;
  gap: 0.5rem;
}

.nav-links li {
  margin: 0;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
  text-decoration: none;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 0.875rem;
  position: relative;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

.nav-link.router-link-active {
  background: rgba(255, 255, 255, 0.15);
  box-shadow: var(--shadow-sm);
}

.nav-link svg {
  flex-shrink: 0;
}

.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--primary-blue-dark) 100%);
  padding: 5rem 1.5rem 2rem;
  z-index: 1040;
  overflow-y: auto;
}

.mobile-nav-links {
  flex-direction: column;
  gap: 0.5rem;
}

.mobile-nav-links .nav-link {
  padding: 1rem 1.25rem;
  font-size: 1rem;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-nav-links .nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateX(4px);
}

.theme-toggle-nav {
  display: flex;
  align-items: center;
  margin: 0 0.25rem;
}

.theme-toggle-nav .theme-toggle-container {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 0.15rem;
  gap: 0.15rem;
}

.theme-toggle-nav .theme-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.85);
  border-radius: 6px;
}

.theme-toggle-nav .theme-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

.theme-toggle-nav .theme-btn.active {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.theme-toggle-nav .theme-btn .icon {
  width: 14px;
  height: 14px;
}

@media (max-width: 768px) {
  .theme-toggle-nav {
    display: none;
  }

  .mobile-theme-toggle {
    margin: 1rem 0;
    padding: 0 1.25rem;
  }

  .mobile-theme-toggle .theme-toggle {
    align-items: stretch;
  }

  .mobile-theme-toggle .theme-toggle-container {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    padding: 0.375rem;
    border-radius: 12px;
  }

  .mobile-theme-toggle .theme-btn {
    color: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
  }

  .mobile-theme-toggle .theme-btn:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }

  .mobile-theme-toggle .theme-btn.active {
    background: rgba(255, 255, 255, 0.2);
    color: white;
    box-shadow: none;
  }

  .mobile-theme-toggle .theme-status {
    text-align: center;
    margin-top: 0.5rem;
  }

  .mobile-theme-toggle .status-text {
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.8rem;
  }
}

/* Desktop theme toggle styles */
.theme-toggle-nav {
  display: flex;
  align-items: center;
  margin-left: 1rem;
}

.theme-toggle-nav .theme-toggle-container {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 0.375rem;
  display: flex;
  gap: 0.25rem;
}

.theme-toggle-nav .theme-btn {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  white-space: nowrap;
}

.theme-toggle-nav .theme-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  color: white;
}

.theme-toggle-nav .theme-btn.active {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  box-shadow: none;
}

.theme-toggle-nav .theme-btn .icon {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.theme-toggle-nav .theme-btn span {
  display: none; /* Hide text on desktop for compact layout */
}

@media (max-width: 768px) {
  .navbar {
    padding: 0.75rem 1rem;
  }
  
  .navbar-left {
    gap: 1rem;
  }
  
  .brand {
    font-size: 1.125rem;
  }
  
  .hamburger {
    display: flex;
    z-index: 1051;
  }

  .desktop-nav {
    display: none;
  }

  .desktop-logout {
    display: none;
  }

  .mobile-menu {
    display: block;
  }

  .goBack {
    padding: 0.375rem 0.75rem;
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .navbar {
    padding: 0.5rem 0.75rem;
  }
  
  .brand {
    font-size: 1rem;
  }
  
  .brand span {
    display: none;
  }
  
  .mobile-menu {
    padding: 4rem 1rem 1.5rem;
  }
  
  .mobile-nav-links .nav-link {
    padding: 0.875rem 1rem;
    font-size: 0.9rem;
  }
}
</style>

<script>
export default {
  data() {
    return {
      isLoggedIn: false,
      isAdmin: false,
      isTeacher: false,
      isAssistant: false,
      menuOpen: false,
    }
  },
  methods: {
    checkAuth() {
      this.getIsAdmin();
      this.getIsTeacher();
      this.getIsAssistant();
      this.getIsLoggedIn();
    },
    getIsAdmin() {
      this.isAdmin = this.$isAdmin();
    },
    getIsTeacher() {
      this.isTeacher = this.$isTeacher();
    },
    getIsAssistant() {
      this.isAssistant = this.$isAssistant();
    },
    getIsLoggedIn() {
      this.isLoggedIn = this.$isLoggedIn();
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    goBack() {
      this.$router.go(-1); 
    }
  },
  mounted() {
    this.checkAuth();
  },
  watch: {
    '$route': 'checkAuth',
  },
};
</script>